import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { useLocation, useHistory } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";

import CounterClockComponent from "../components/exam/components/CounterClockComponent";
import CounterClockSoundComponent from "../components/exam/components/CounterClockSoundComponent";
import '../../css/examscreen.css';
import co_logo from "../../images/clv_logo.png";
import demo_user from "../../images/demo_user.png";
import dashboard from "../../images/dashboard.png";
import instruction from "../../images/Instruction.png";
import { ToastContainer } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Loader from "../components/Loader";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

import DatePicker from "react-datepicker";

import {
  getScholasticExamQuestionsData,
  loadingBranchScholasticAction,
  submitScholasticExam,
  getScholasticQuestionListAction,
} from "../../store/actions/ScholasticAction";
import {
  selectDemoQuestionNumber,
  selectPrevousDemoQuestion,
  selectNextDemoQuestion,
  timeUpAction,
} from "../../store/actions/demoExamAction";
import {
  newStudentRegistration,
  newStudentRegistrationWithoutDemo,
  showingLoaderStudentAction,
  demoUserRecordExistsOrNot,
  sendVerificationOtp,
  verificationCodeAction,
  recordExistsSuccess,
  registrationStatusDetails,
  postDemoStudentRegistrationAction,
} from "../../store/actions/StudentAction";
import {
  getBoardData,
  loadingBoardAction,
  getSchoolListData,
  getSchoolListFailureAction,
  selectSchoolNameListAction,
  schoolNameShowingLoaderAction,
} from "../../store/actions/BoardActions";
import {
  getClassStandardData,
  loadingClassStandardAction,
} from "../../store/actions/ClassStandardAction";
import {
  getAcademicYearByBoardList,
  academicYearLoading,
  getAcademicYearByBoardIdAction,
} from "../../store/actions/AcademicActions";

import * as utility from "../../utility/Utility";
import swal from "sweetalert";
import TermsCondition from "./TermsCondition";

import CreatableSelect from "react-select/creatable";
import ExamInstruction from "../components/ExamInstruction";

const DemoScholasticExamStart = (props) => {
  const status = useSelector((state) => state.student.status);
  //const newStudentid = useSelector((state) => state.student.newStudentid);
  const demoExamSubmit = useSelector(
    (state) => state.questionNo.demoExamDoneOrNot
  );
  const schoolList = useSelector((state) => state.board.schoolList);
  const warningSound = useSelector((state) => state.questionNo.warningSound); //-----
  const timeUpWarning = useSelector((state) => state.questionNo.timeUpWarning); //-----
  const time_used = useSelector((state) => state.questionNo.time_used);

  const [instructionExamModal, setInstructionExamModal] = useState(false);
  const [informationModal, setInformationModal] = useState(false);
  const [timeUpModal, setTimeUpModal] = useState(false);

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [is_visited_count, setIs_visited_count] = useState(0);
  const [is_answered_count, setIs_answered_count] = useState(0);

  const [newStudentid, setNewStudentid] = useState("");
  const [previousValue, setPrevousValue] = useState(location.state);
  const [selected, setSelected] = useState([]);
  const [showQuestion, setShowQuestion] = useState(false);

  const [examTime, setExamTime] = useState(0);
  const [registrationModal, setRegistrationModal] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [otpVerificationModal, setOtpVerificationModal] = useState(false);
  const [selectQuestion, setSelectQuestion] = useState();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [testCgaracter, setTestCgaracter] = useState("");
  const [timerOn, setTimerOn] = useState(false);
  const [remainingHours, setRemainingHours] = useState();
  const [remainingMinutes, setRemainingMinutes] = useState();
  const [remainingSeconds, setRemainingSeconds] = useState();
  const [isPlaying, setIsPlaying] = useState(true);
  const [showResendOtp, setShowResendOtp] = useState(false);
  const [verifyButtonShow, setVerifyButtonShow] = useState(true);
  const [showOtpValidationTimer, setShowOtpValidationTimer] = useState(false);
  const [viewPassword, setViewPassword] = useState("password");
  const [viewCPassword, setViewCPassword] = useState("password");
  const [alertSound, setAlertSound] = useState(0);

  const [schoolNameList, setSchoolNameList] = useState([]);
  const [onlySchoolName, setOnlySchoolName] = useState([]);
  const [schoolAddress, setSchoolAddress] = useState([]);
  const [blankSchoolNameList, setBlankSchoolNameList] = useState(0);
  const [defalutValue, setDefalutValue] = useState("option");
  const [defalutValueBlank, setDefalutValueBlank] = useState(null);
  const isShowSchoolList = useSelector((state) => state.board.isShowSchoolList);

  const [isDemo, setIsDemo] = useState("");

  const [termsAndConditionModal, SetTermsAndConditionModal] = useState(false);

  const [isSubmit, setIsSubmit] = useState(0);

  /* fullScreen  off and on */
  const fullScreeTtoggleChange = () => {
    setIsFullScreen(!isFullScreen);
    if (isFullScreen == true) {
      launchFullscreen(document.documentElement);
    } else {
      exitFullscreen();
    }
  };

  let errorsObj = {
    fname: "",
    lname: "",
    mobile: "",
    email: "",
    std: "",
    academic: "",
    board: "",
    motp: "",
    eotp: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [userdob, setUserdob] = useState();
  const [userDetails, setUserDetails] = useState({
    fname: "",
    lname: "",
    mobile: "",
    email: "",
    std: "",
    board: "",
    academic: "",
    motp: "",
    eotp: "",
  });
  const fnameRef = useRef();
  const lnameRef = useRef();
  const addressRef = useRef();
  const pincodeRef = useRef();
  const mobileRef = useRef();
  const emailRef = useRef();
  const passwordRef = useRef();
  const cpasswordRef = useRef();
  const stdRef = useRef();
  const academicRef = useRef();
  const boardRef = useRef();
  const schoolnameRef = useRef();
  const schooladdRef = useRef();
  const mobileOtpRef = useRef();
  const emailOtpRef = useRef();
  const InstructionExamModalRef = useRef(true);
  const otpModalRef = useRef(true);

  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState(null);
  const [infoBox, setInfoBox] = useState(false);
  const [userImage, setUserImage] = useState(demo_user);

  useEffect(() => {
    let getData = localStorage.getItem("userDetails");
    let profile_pic = JSON.parse(getData).profile_pic;
    let userId = JSON.parse(getData).id;

    setUserImage(
      profile_pic != "" && profile_pic != undefined && profile_pic != null
        ? profile_pic
        : demo_user
    );

    if (userId > 0) {
      dispatch(
        postDemoStudentRegistrationAction(userId)
      ); /* create userid when guest user registration completed */
    }

    const handleContextmenu = (e) => {
      e.preventDefault();
    };
    document.addEventListener("contextmenu", handleContextmenu);

    if (InstructionExamModalRef.current) {
      dispatch(
        selectDemoQuestionNumber(0)
      ); /* when exam start set question no strat from 0 */
      setInstructionExamModal(true); /* show instrction modal */
      dispatch(
        loadingBranchScholasticAction(true)
      ); /* question loader showing when qustion loading */
      dispatch(
        getScholasticExamQuestionsData(props.history)
      ); /* get Scholastic Exam question details */
    }
    InstructionExamModalRef.current = false;
    dispatch(
      loadingBoardAction(true)
    ); /* board loader showing when board data loading */
    dispatch(getBoardData(props.history)); /* get board data */
    dispatch(
      loadingClassStandardAction(true)
    ); /* class loader showing when class data loading */
    dispatch(getClassStandardData(props.history)); /* get class data */

    if (status == 0 && status != null) {
      setOtpVerificationModal(true); /* verification modal show */
      setInstructionExamModal(false); /* exam instruction modal close */
      setRegistrationModal(false); /* regostration modal close */
      dispatch(
        showingLoaderStudentAction(true)
      ); /* showing loader for demo user send OTP  */
      dispatch(
        sendVerificationOtp(
          userDetails.mobile,
          userDetails.email,
          props.history
        )
      ); /* Send verification OTP to user  */
    }

    // if (newStudentid != null && newStudentid != undefined && demoExamSubmit == 0 && !!props.scholasticQuestionList.length) {
    // if (newStudentid != null && newStudentid != undefined && demoExamSubmit == 0 && !!props.scholasticQuestionList.length && isSubmit == 1) {
    //   submitDemoExam();
    //   exitFullscreen();
    // }

    const interval = setInterval(() => {
      showEquition();
    }, 100);

    showEquition(); /* show equition in question and answer */

    if (isShowSchoolList == 1) {
      setSchoolNameList(props.schoolList);
    }

    if (isShowSchoolList == 1) {
      /* to be Deleted */
      setOnlySchoolName([]);
      let schoolName = [];
      schoolNameList.forEach((elm) => {
        schoolName.push(elm.school_name);
      });
      setOnlySchoolName(schoolName);
      /* to be Deleted */

      let selectSchoolNameBoardWise = [];
      let selectSchoolName = {};
      schoolNameList.forEach((elm) => {
        selectSchoolName = {};
        selectSchoolName["value"] = elm.school_name;
        selectSchoolName["label"] = elm.school_name;
        selectSchoolNameBoardWise.push(selectSchoolName);
      });
      setOptions(selectSchoolNameBoardWise);
      dispatch(
        schoolNameShowingLoaderAction(false)
      ); /* showing loader off when school list load completed */
    }

    if (blankSchoolNameList == 1) {
      setUserDetails((userDetails) => ({
        ...userDetails,
        fname: "",
        lname: "",
        dob: "",
        gender: "",
        address: "",
        pincode: "",
        mobile: "",
        email: "",
        password: "",
        cpassword: "",
        std: "",
        academic: "",
        board: "",
        schoolname: "",
        schooladd: "",
        motp: "",
        eotp: "",
      }));
      setUserdob("");
      setOnlySchoolName([]);
      dispatch(getSchoolListFailureAction([])); /* School List Blank */
    }
    setBlankSchoolNameList(0);

    return () => {
      document.removeEventListener("contextmenu", handleContextmenu);
      clearInterval(interval);
      setAlertSound(0);
    };
  }, [
    status,
    newStudentid,
    demoExamSubmit,
    schoolNameList,
    schoolList,
    isShowSchoolList,
    isPlaying,
  ]);

  useEffect(() => {
    dispatch(selectSchoolNameListAction(0));

    const preventUnload = (event) => {
      // NOTE: This message isn't used in modern browsers, but is required
      const message = "Sure you want to leave?";
      event.preventDefault();
      return (event.returnValue = message);
    };

    window.addEventListener("beforeunload", preventUnload);

    return () => {
      window.removeEventListener("beforeunload", preventUnload);
      // console.log("window.removeEventListener('beforeunload', preventUnload);")
    };
  }, []);

  useEffect(() => {
    return () => {
      setIsSubmit(0);
    };
  }, []);
  //-----
  useEffect(() => {
    // document.addEventListener('keydown', detectKeyDown, true)
    if (timeUpWarning == 1) {
      setTimeUpModal(true);
    }
  }, [warningSound, timeUpWarning]);

  useEffect(() => {
    // console.log("time_used-----11---", time_used)
  }, [time_used]);
  //-----
  useEffect(() => {
    if (fnameRef.current) {
      fnameRef.current.focus();
    }
  }, []);

  useEffect(() => {
    return () => {
      dispatch(
        getScholasticQuestionListAction([])
      ); /* when quit from this page Scholastic Exam question upload as blank */
    };
  }, []);

  useEffect(() => {
    let getData = localStorage.getItem("userDetails");
    let user_id = JSON.parse(getData).id;
    setIsDemo(user_id);
  }, []);

  useEffect(() => {
    if (!!props.scholasticQuestionList.length) {
      var handler = document.querySelector(".handler");
      var wrapper = document.querySelector(".answer_top_container");
      var boxA = wrapper.querySelector(".question_heading");
      var boxB = wrapper.querySelector(".checkbox_from_container");
      var isHandlerDragging = false;

      document.addEventListener("mousedown", function (e) {
        // If mousedown event is fired from .handler, toggle flag to true
        if (e.target === handler) {
          isHandlerDragging = true;
        }
      });

      document.addEventListener("mousemove", function (e) {
        // Don't do anything if dragging flag is false
        if (!isHandlerDragging) {
          return false;
        }

        e.preventDefault();

        // Get offset
        var containerOffsetTop = wrapper.offsetTop;
        var containerOffsetBottom = wrapper.offsetBottom;

        // Get x-coordinate of pointer relative to container
        var pointerRelativeXpos = e.clientY - containerOffsetTop;
        var pointerRelativeXpos2 = e.clientY - e.offsetTop + e.offsetHeight;

        var boxAminWidth = 30;

        boxA.style.height =
          Math.max(boxAminWidth, pointerRelativeXpos - 2) + "px";
        boxB.style.height =
          Math.max(boxAminWidth, pointerRelativeXpos2 - 8) + "px";
      });
      document.addEventListener("mouseup", function (e) {
        // Turn off dragging flag when user mouse is up
        isHandlerDragging = false;
      });
    }
    // }, 5000)
  }, [props.scholasticQuestionList]);

  useEffect(() => {
    if (!!props.scholasticQuestionList.length) {
      var wrapper = document.querySelector(".answer_top_container");
      var boxA = wrapper.querySelector(".question_heading");
      boxA.style.height = "250px";
    }
  }, [props.questionNo]);

  const detectKeyDown = (e) => {
    console.log("clicked Key:", e.key);
    if (e.key === "Control") {
      console.log("you have pressed Control Key");
      return;
    }
    /* if (e.key === "ArrowRight") {
            nextQuestion(props.questionNo)
            console.log("you have pressed Right Key")
        } else if (e.key === "ArrowLeft") {
            prevousQuestion(props.questionNo)
            console.log("you have pressed Right Key")
        } */
  };

  /* show Math equition */
  const showEquition = () => {
    if (typeof window?.MathJax !== undefined) {
      window.MathJax.typesetClear();
      window.MathJax.typeset();
      window.MathJax.typesetPromise();
    }
  };
  /* show Full Screen */
  const launchFullscreen = (element) => {
    // if (element.requestFullscreen) {
    //   element.requestFullscreen();
    // } else if (element.mozRequestFullScreen) {
    //   element.mozRequestFullScreen();
    // } else if (element.webkitRequestFullscreen) {
    //   element.webkitRequestFullscreen();
    // } else if (element.msRequestFullscreen) {
    //   element.msRequestFullscreen();
    // }
  };

  const exitFullscreen = () => {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        // Chrome, Safari, and Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // IE/Edge
        document.msExitFullscreen();
      }
    } else {
      console.warn("Document is not in fullscreen mode.");
    }
  };

  /* instruction off and start Exam */
  const startExam = () => {
    setInstructionExamModal(false);
    setShowQuestion(true);
    launchFullscreen(document.documentElement);
    props.scholasticQuestionList[props.questionNo].is_visited = 1;
    visited_count();

    if (isPlaying) {
      // startTimer(); //-----
    }
  };

  let counterTimerobj;

  /* start Exam time */
  const startTimer = () => {
    var examTime = 60 * props.scholasticQuestionList[0].exam_duration;
    // var examTime = 60 * 1;
    var timer = examTime,
      minutes,
      seconds;

    counterTimerobj = setInterval(function () {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      setExamTime(minutes + ":" + seconds);

      if (timer <= 300 && timer >= 295) {
        setAlertSound(1);
      } else if (timer <= 294) {
        setAlertSound(0);
      }

      if (--timer == 0 || !isPlaying) {
        minutes = "00";
        seconds = "00";
        setExamTime(minutes + ":" + seconds);
        if (isPlaying) {
          setTimeUpModal(true);
        }
        clearInterval(counterTimerobj);
      }
    }, 1000);
  };

  /* updated select question number */
  const questNumber = (id) => {
    dispatch(
      selectDemoQuestionNumber(id)
    ); /* current question store into action */
    if (props.scholasticQuestionList[id].is_visited == 1) {
      if (props.scholasticQuestionList[id].is_answered == 1) {
        props.scholasticQuestionList[id].is_visited = 0;
      } else {
        //do nothing
      }
    } else {
      if (
        props.scholasticQuestionList[id].is_answered &&
        props.scholasticQuestionList[id].is_answered == 1
      ) {
        props.scholasticQuestionList[id].is_visited = 0;
      } else {
        props.scholasticQuestionList[id].is_visited = 1;
      }
      answer_count();
      visited_count();
    }
  };

  /* quit from exam and back to dashboard */
  const backToDashboard = () => {
    dispatch(getSchoolListFailureAction([])); /* School list blank */
    setRegistrationModal(false);
    history.push({ pathname: "/dashboard" });
    exitFullscreen();
  };

  /* Select previous Question */
  const prevousQuestion = (currentNumber) => {
    dispatch(
      selectPrevousDemoQuestion(currentNumber - 1)
    ); /* previous current question store into action */
    props.scholasticQuestionList[currentNumber - 1].is_visited = 1;
    visited_count();
    if (props.scholasticQuestionList[currentNumber - 1].is_answered == 1) {
      props.scholasticQuestionList[currentNumber - 1].is_visited = 0;
    } else {
      //do nothing
    }
  };

  /* Select next Question */
  const nextQuestion = (currentNumber) => {
    dispatch(
      selectNextDemoQuestion(currentNumber + 1)
    ); /* next current question store into action */
    props.scholasticQuestionList[currentNumber + 1].is_visited = 1;
    visited_count();
    if (props.scholasticQuestionList[currentNumber + 1].is_answered == 1) {
      props.scholasticQuestionList[currentNumber + 1].is_visited = 0;
    } else {
      //do nothing
    }
  };

  /* Select answer option Question */
  const answerSetSelected = (data, index) => {
    let temp_data = [...selected];
    temp_data[props.questionNo] = data;

    setSelected(temp_data);
    props.scholasticQuestionList[props.questionNo].is_answered = 1;
    props.scholasticQuestionList[props.questionNo].is_answered_data = data;
    props.scholasticQuestionList[props.questionNo].is_visited = 0;
    answer_count();
    visited_count();
    if (
      utility.decryptAES(
        props.scholasticQuestionList[props.questionNo].answer
      ) == data
    ) {
      props.scholasticQuestionList[props.questionNo].is_corrected = 1;
    } else {
      props.scholasticQuestionList[props.questionNo].is_corrected = 0;
    }
  };

  /* how many qustion visit this exam */
  const visited_count = () => {
    var rez = 0;
    props.scholasticQuestionList.forEach(function (item) {
      if (item.is_visited >= 0) {
        rez++;
      }
    });
    setIs_visited_count(rez);
  };

  /* how many questions give answer this exam */
  const answer_count = () => {
    var rez = 0;
    props.scholasticQuestionList.forEach(function (item) {
      if (item.is_answered >= 0) {
        rez++;
      }
    });
    setIs_answered_count(rez);
  };

  const onFnameHandler = (val) => {
    setUserDetails({ ...userDetails, fname: val });
  };

  const onLnameHandler = (val) => {
    setUserDetails({ ...userDetails, lname: val });
  };

  const onClassHandler = (val) => {
    setUserDetails({ ...userDetails, std: val });
  };

  const onBoardHandler = (val) => {
    setUserDetails({ ...userDetails, board: val });
    if (val) {
      dispatch(getAcademicYearByBoardList(parseInt(val), history));
    } else {
      dispatch(getAcademicYearByBoardIdAction([]));
    }
  };

  const onMobileHandler = (val) => {
    setUserDetails({ ...userDetails, mobile: val });
  };

  const onEmailHandler = (val) => {
    setUserDetails({ ...userDetails, email: val });
  };

  const onAcademicHandler = (val) => {
    setUserDetails({ ...userDetails, academic: val });
  };

  const onMotpHandler = (val) => {
    setUserDetails({ ...userDetails, motp: val });
  };

  const onEotpHandler = (val) => {
    setUserDetails({ ...userDetails, eotp: val });
  };

  /* validation registration form */
  const demouserRegister = (e) => {
    e.preventDefault();

    const re = /^[A-Za-z\s]+$/;
    const onlyNumber = /^[0-9]+$/;
    const { fname, lname, mobile, email, std, academic, board } = userDetails;

    let error = false;

    const errorObj = { ...errorsObj };

    if (fname.trim() === "") {
      fnameRef.current.focus();
      errorObj.fname = "First name is Required";
      error = true;
    } else if (fname.length < 3) {
      fnameRef.current.focus();
      errorObj.fname = "Minimum 3 Character is Required";
      error = true;
    } else if (!re.test(fname)) {
      fnameRef.current.focus();
      errorObj.fname = "Allow only alphabets";
      error = true;
    }

    if (lname === "") {
      errorObj.lname = "Last name is Required";
      lnameRef.current.focus();
      error = true;
    } else if (lname.length < 3) {
      errorObj.lname = "Minimum 3 Character is Required";
      lnameRef.current.focus();
      error = true;
    } else {
      if (!re.test(lname)) {
        errorObj.lname = "Allow only alphabets";
        lnameRef.current.focus();
        error = true;
      }
    }

    if (mobile === "") {
      errorObj.mobile = "Mobile is Required";
      mobileRef.current.focus();
      error = true;
    } else if (mobile.length < 10) {
      errorObj.mobile = "Check Mobile No.";
      mobileRef.current.focus();
      error = true;
    } else if (!onlyNumber.test(mobile)) {
      errorObj.mobile = "Allow only numeric";
      mobileRef.current.focus();
      error = true;
    } else if (mobile == "0000000000") {
      errorObj.mobile = "Not a valid number";
      mobileRef.current.focus();
      error = true;
    }

    if (email === "") {
      errorObj.email = "Email is Required";
      emailRef.current.focus();
      error = true;
    } else if (utility.validateEmail(email)) {
      errorObj.email = "Not a Valid Email";
      emailRef.current.focus();
      error = true;
    }

    if (academic === "" || academic === "Select academic year") {
      errorObj.academic = "Academic Year is Required";
      academicRef.current.focus();
      error = true;
    }

    if (std === "") {
      errorObj.std = "Standard is Required";
      stdRef.current.focus();
      error = true;
    }
    if (board === "") {
      errorObj.board = "Board is Required";
      boardRef.current.focus();
      error = true;
    }

    setErrors(errorObj);
    if (error) {
      return;
    } else {
      SetTermsAndConditionModal(true);
      studentDetailsBeforeOtpVerify();
      setRegistrationModal(false);
      //dispatch(showingLoaderStudentAction(true));
      //dispatch(demoUserRecordExistsOrNot(mobile, email, props.history))
      // setOtpVerificationModal(true);
    }
  };

  /* check user details exists or not */
  const checkUserRecord = () => {
    SetTermsAndConditionModal(false);
    dispatch(showingLoaderStudentAction(true));
    dispatch(
      demoUserRecordExistsOrNot(
        userDetails.mobile,
        userDetails.email,
        checkUserRecordCallBack,
        history
      )
    );
  };

  const checkUserRecordCallBack = (data) => {
    if (data == 0) {
      setOtpVerificationModal(true);
      dispatch(
        sendVerificationOtp(userDetails.mobile, userDetails.email, history)
      );
    }
  };

  /* validation registration OTP form */
  const verifyOtp = (e) => {
    e.preventDefault();
    const { fname, lname, mobile, email, std, board, academic } = userDetails;

    const re = /^[A-Za-z]+$/;
    const onlyNumber = /^[0-9]+$/;

    const { motp, eotp } = userDetails;
    let error = false;
    const errorObj = { ...errorsObj };

    if (motp === "") {
      mobileOtpRef.current.focus();
      errorObj.motp = "Mobile OTP is required";
      error = true;
    } else if (!onlyNumber.test(motp)) {
      mobileOtpRef.current.focus();
      errorObj.motp = "Allow only numeric";
      error = true;
    } else if (motp.length < 6) {
      mobileOtpRef.current.focus();
      errorObj.motp = "Verify your OTP";
      error = true;
    }

    if (eotp === "") {
      emailOtpRef.current.focus();
      errorObj.eotp = "Email OTP is required";
      error = true;
    } else if (!onlyNumber.test(eotp)) {
      emailOtpRef.current.focus();
      errorObj.eotp = "Allow only numeric";
      error = true;
    } else if (eotp.length < 6) {
      emailOtpRef.current.focus();
      errorObj.eotp = "Verify your OTP";
      error = true;
    }

    setErrors(errorObj);
    if (error) {
      return;
    } else {
      if (
        userDetails.eotp == utility.decryptAES(props.eOtp) &&
        userDetails.motp == utility.decryptAES(props.mOtp)
      ) {
        exitFullscreen();
        dispatch(showingLoaderStudentAction(true));
        /* guest user data send for registration */
        //newStudentRegistration
        dispatch(
          newStudentRegistrationWithoutDemo(
            fname.trim(),
            lname.trim(),
            mobile.trim(),
            email,
            std,
            board,
            academic,
            registerUserCallback,
            props.history
          )
        );
      } else {
        /* if OTP mismatch */
        dispatch(
          registrationStatusDetails(
            mobile.trim(),
            email,
            `${fname.trim()} ${lname.trim()}`,
            userDetails.motp == utility.decryptAES(props.mOtp) ? 1 : 0,
            userDetails.eotp == utility.decryptAES(props.eOtp) ? 1 : 0,
            1,
            userDetails.std,
            userDetails.board,
            userDetails.pincode,
            userDetails.schoolname
          )
        );

        alert("Verify your OTP");
      }
    }
  };

  const registerUserCallback = (data) => {
    setRegistrationModal(false);
    setOtpVerificationModal(false);
    const removeOtp = {
      email_otp: "",
      mobile_otp: "",
    };
    dispatch(verificationCodeAction(removeOtp));
    setNewStudentid(data.studentid);
    submitDemoExam(
      data.studentid,
      0
    ); /* After registration submit demo exam  */
    exitFullscreen();
    //history.push("/page-register-success");
  };

  const studentDetailsBeforeOtpVerify = () => {
    dispatch(
      registrationStatusDetails(
        userDetails.mobile.trim(),
        userDetails.email,
        `${userDetails.fname.trim()} ${userDetails.lname.trim()}`,
        userDetails.motp == utility.decryptAES(props.mOtp) ? 1 : 0,
        userDetails.eotp == utility.decryptAES(props.eOtp) ? 1 : 0,
        1,
        userDetails.std,
        userDetails.board
      )
    );
  };

  /* Demo Exam Submit */
  const submitDemoExam = (student_id, type) => {
    console.log("type..", type);
    const exam_category_id = 1;
    var examdata = [];
    var id_wise_value = null;
    console.log("type..1", type);
    for (var i = 0; i < props.scholasticQuestionList.length; i++) {
      id_wise_value = {};
      id_wise_value["question_id"] = props.scholasticQuestionList[i].id;
      id_wise_value["question_no"] =
        props.scholasticQuestionList[i].question_no;
      id_wise_value["guest_post_ans"] =
        props.scholasticQuestionList[i].is_answered_data;
      id_wise_value["guest_post_ans_status"] =
        props.scholasticQuestionList[i].is_corrected;
      examdata.push(id_wise_value);
    }
    console.log("type..3", type);
    if (student_id) {
      console.log("type..4", type);
      dispatch(submitScholasticExam(
        examdata,
        student_id,
        exam_category_id,
        type,
        props.history
      )); /* exam submit when guest user registered */
    }
  };

  /* Submit exam and check user demo or not */
  const submitFinalAnswer = () => {
    setIsPlaying(false);
    dispatch(timeUpAction(0));
    if (props.user_id == 0 || props.user_id == "") {
      setIsPlaying(false);
      setRegistrationModal(true);
    } else {
      exitFullscreen();
      submitDemoExam(props.user_id, 1);
      // exitFullscreen();
      // submitDemoExam();
      // if (demoExamSubmit == 1) {
      //   exitFullscreen();
      //   submitDemoExam();
      // }
    }
  };

  /* Submit exam if time up */
  const timeUpSubmit = () => {
    // console.log("timeUpSubmit")
    dispatch(timeUpAction(0)); //-----
    setIsPlaying(false);
    // setTimeUpModal(false);///////////
    submitFinalAnswer();
  };

  const onChange = (date) => {
    // Day.js object
    // console.log(date);

    // to normal Date object
    // console.log(date.toDate());
    setUserDetails((userDetails.email = date));
  };

  const selectDate = () => {
    setShowDatePicker(true);
  };

  /* OTP verify time count */
  const renderTime = ({ remainingTime }) => {
    if (remainingTime === 0) {
      // return <div className="timer">Too lale...</div>;
      const removeOtp = {
        email_otp: "",
        mobile_otp: "",
      };
      setUserDetails((userDetails) => ({
        ...userDetails,
        motp: "",
        eotp: "",
      }));

      dispatch(
        verificationCodeAction(removeOtp)
      ); /* remove OTP from action or reducer when time is expired */
      setShowResendOtp(true); /* show resend button when time is expired */
      setShowOtpValidationTimer(true);
      setVerifyButtonShow(
        false
      ); /* hide verification button when time is expired */
      dispatch(
        registrationStatusDetails(
          userDetails.mobile,
          userDetails.email,
          `${userDetails.fname} ${userDetails.lname}`,
          0,
          0,
          2,
          userDetails.std,
          userDetails.board
        )
      ); /* send OTP verfication details */
    }

    return (
      <div className="timer">
        {/* <div className="small_text">Remaining</div> */}
        <div className="remainingTime">{remainingTime}</div>
        {/* <div className="small_text">seconds</div> */}
      </div>
    );
  };

  /* resend registration otp */
  const resendOtp = () => {
    dispatch(showingLoaderStudentAction(true));
    dispatch(
      sendVerificationOtp(userDetails.mobile, userDetails.email, props.history)
    ); /* resend verfication code to user mobile and email */
    setShowResendOtp(false); /* hide resend button when received new OTP */
    setVerifyButtonShow(
      true
    ); /* show verification button when received new OTP  */
  };

  /* show password */
  const showPassword = () => {
    // console.log("viewPassword--", viewPassword)
    if (viewPassword == "password") {
      setViewPassword("text");
    } else {
      setViewPassword("password");
    }
  };

  /* otp verification modal close  */
  const closeOtpVerificationModal = () => {
    dispatch(recordExistsSuccess(null));
    setOtpVerificationModal(false);
    setUserDetails((userDetails) => ({
      ...userDetails,
      // fname: '',
      // lname: '',
      // dob: '',
      // gender: '',
      // address: '',
      // pincode: '',
      // mobile: '',
      // email: '',
      password: "",
      cpassword: "",
      /* std: '',
            board: '', */
      schoolname: "",
      schooladd: "",
      motp: "",
      eotp: "",
    }));
    // setUserdob('')
    // setOnlySchoolName([]);
    // dispatch(getSchoolListFailureAction([]));

    setShowResendOtp(false);
    setVerifyButtonShow(true);
    exitFullscreen();
    history.push({ pathname: "/dashboard" });
  };

  /* confirmation before Exam submit  */
  const submitFinalAnswerWithAlert = () => {
    swal({
      title: "Do you want to submit?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        setIsSubmit(1);
        submitFinalAnswer();
      }
    });
  };

  /* confirmation before back to Dashboard  */
  const gobackDashboardWithAlert = () => {
    swal({
      title: "Do you want to go back to dashboard?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        backToDashboard();
      }
    });
  };

  return (
    <>
      {/* <div className="body_container">
        <div className="container-fluid w-100 bg-white rounded p-1 mb-4">
          <div className="d-flex flex-wrap gap-2 justify-content-between">

            <div className="box box1 text-center rounded p-2">
              <img
                src={co_logo}
                className="exam_start_logo"
                alt="profile"
              />
            </div>
            <div className="box box2 text-center rounded p-2 d-flex justify-content-center align-items-center">
              <div>
                <h5>
                  Scholastic {`>`} {isDemo == 0 ? `Guest` : `Registered`}{" "}
                  Demo Exam
                </h5>
              </div>
            </div>

            <div className="box box3 text-center rounded p-2 d-flex justify-content-center align-items-center">
              
            </div>
            <div className="box box4 text-center rounded p-2">
              <Link to="#" className="link_container">
                <div
                  className="fullScreen"
                  onClick={() => fullScreeTtoggleChange()}
                >
                  {isFullScreen ? (
                    <i className="bi bi-arrows-fullscreen text_blue"></i>
                  ) : (
                    <i className="bi bi-fullscreen-exit text_blue"></i>
                  )}
                </div>
                <div className="icon_description text_blue">
                  Full Screen
                </div>
              </Link>
            </div>
            <div className="box box5 text-center rounded p-2">
              <Link to="#" className="link_container">
                <div
                  className="image-container"
                  onClick={() => setInformationModal(true)}
                >
                  <img
                    src={instruction}
                    className="right_side_icon_size"
                    alt="CreaTest"
                  />
                </div>
                <div className="icon_description text_blue">
                  Instruction
                </div>
              </Link>
            </div>
            <div className="box box6 text-center rounded p-2">
              <Link
                to="#"
                className="link_container"
                onClick={() => gobackDashboardWithAlert()}
              >
                <div className="right_indidual_contaoiner">
                  <div className="image-container">
                    <img
                      src={dashboard}
                      className="right_side_icon_size"
                      alt="CresTest"
                    />
                  </div>
                  <div className="icon_description text_blue">
                    Dashboard
                  </div>
                </div>
              </Link>
            </div>
            <div className="box box7 text-center rounded p-2">
              <Link to="#" className="link_container">
                <div className="image-container">
                  <img
                    src={userImage}
                    className="right_side_icon_size border_radious_50 userImageSize"
                    alt="CreaTest"
                  />
                </div>
                <div className="icon_description text_blue">
                  {props.user_name.split(" ")[0]}
                </div>
              </Link>
            </div>

          </div>
        </div>
        <div className="d-flex flex-column flex-md-row gap-4 h-100">

          <div className="rounded bg-white p-4" style={{ flex: '0 0 75%' }}>
            Left Section (80%)
          </div>

          <div className="rounded bg-white p-4" style={{ flex: '0 0 23.5%' }}>
            Right Section (20%)
          </div>

        </div>

      </div> */}

      <div className="body_container">
        {props.scholasticQuestionList != "" ? (
          <>
            <div className="container-fluid w-100 bg-white rounded p-1 mb-4">
              <div className="d-flex flex-wrap gap-2 justify-content-between">

                <div className="box box1 text-center rounded p-2">
                  <img
                    src={co_logo}
                    className="exam_start_logo"
                    alt="profile"
                  />
                </div>
                <div className="box box2 text-center rounded p-2 d-flex justify-content-center align-items-center">
                  <div>
                    <h5>
                      Scholastic {`>`} {isDemo == 0 ? `Guest` : `Registered`}{" "}
                      Demo Exam
                    </h5>
                  </div>
                </div>

                <div className="box box3 text-center rounded p-2 d-flex justify-content-center align-items-center">
                  <div className="timer_ounter">
                    {showQuestion ? (
                      <>
                        <CounterClockComponent
                          examTime={
                            props.scholasticQuestionList[0].exam_duration
                          }
                          isPlaying={isPlaying}
                        />
                        {/* <CounterClockComponent examTime={15} isPlaying={isPlaying} /> */}
                      </>
                    ) : (
                      <div className="clock_icon">
                        <i className="mdi mdi-clock"></i>
                      </div>
                    )}
                  </div>
                </div>
                <div className="box box4 text-center rounded p-2">
                  <Link to="#" className="link_container">
                    <div
                      className="fullScreen"
                      onClick={() => fullScreeTtoggleChange()}
                    >
                      {isFullScreen ? (
                        <i className="bi bi-arrows-fullscreen text_blue"></i>
                      ) : (
                        <i className="bi bi-fullscreen-exit text_blue"></i>
                      )}
                    </div>
                    <div className="icon_description text_blue">
                      Full Screen
                    </div>
                  </Link>
                </div>
                <div className="box box5 text-center rounded p-2">
                  <Link to="#" className="link_container">
                    <div
                      className="image-container"
                      onClick={() => setInformationModal(true)}
                    >
                      <img
                        src={instruction}
                        className="right_side_icon_size"
                        alt="CreaTest"
                      />
                    </div>
                    <div className="icon_description text_blue">
                      Instruction
                    </div>
                  </Link>
                </div>
                <div className="box box6 text-center rounded p-2">
                  <Link
                    to="#"
                    className="link_container"
                    onClick={() => gobackDashboardWithAlert()}
                  >
                    <div className="right_indidual_contaoiner">
                      <div className="image-container">
                        <img
                          src={dashboard}
                          className="right_side_icon_size"
                          alt="CresTest"
                        />
                      </div>
                      <div className="icon_description text_blue">
                        Dashboard
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="box box7 text-center rounded p-2">
                  <Link to="#" className="link_container">
                    <div className="image-container">
                      <img
                        src={userImage}
                        className="right_side_icon_size border_radious_50 userImageSize"
                        alt="CreaTest"
                      />
                    </div>
                    <div className="icon_description text_blue">
                      {props.user_name.split(" ")[0]}
                    </div>
                  </Link>
                </div>

              </div>
            </div>
            <div className="d-flex flex-column flex-md-row gap-4 height-md-80vh ">
              <div className="rounded bg-white " style={{ flex: '1', height: '80vh' }}>
                <div className="answer_container">
                  <div className="answer_top_container parent_container_new">
                    <div className="question_heading text_black unselect_text precent_text">
                      {showQuestion ? (
                        <>
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                props.scholasticQuestionList[props.questionNo]
                                  .question,
                            }}
                          ></div>
                        </>
                      ) : null}
                    </div>
                    <div className="handler"></div>

                    {showQuestion ? (
                      props.scholasticQuestionList.length <= 0 ? null : (
                        <form
                          className="checkbox_from_container"
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <div className="checkbox_container">
                            <div className="container">
                              <div className="checkbox_inside_container unselect_text">
                                <div className="row option_container">
                                  {Object.keys(
                                    props.scholasticQuestionList[props.questionNo]
                                      .options[0]
                                  ).map(([key, value]) => {
                                    return (
                                      <React.Fragment key={key}>
                                        <div className="form-group col-md-12 display_flex">
                                          <div
                                            className="form-check mb-2 modern-radio-container"
                                            onClick={() => {
                                              answerSetSelected(key);
                                            }}
                                          >
                                            {selected[props.questionNo] == key ? (
                                              <>
                                                <div className="key_value">
                                                  {key}
                                                  {":"}
                                                </div>
                                                <div className="radio-outer-circle unselected">
                                                  <i className="mdi mdi-check check_mark"></i>
                                                </div>

                                                <div className="helper-text">
                                                  <div
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        props
                                                          .scholasticQuestionList[
                                                          props.questionNo
                                                        ].options[0][key],
                                                    }}
                                                  ></div>
                                                </div>
                                              </>
                                            ) : (
                                              <>
                                                <div className="key_value">
                                                  {key}
                                                  {":"}
                                                </div>
                                                <div className="radio-outer-circle unselected"></div>

                                                <div className="helper-text">
                                                  <div
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        props
                                                          .scholasticQuestionList[
                                                          props.questionNo
                                                        ].options[0][key],
                                                    }}
                                                  ></div>
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      </React.Fragment>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      )
                    ) : null}
                  </div>
                  <div className="display_question_number blue_background" >
                    {props.scholasticQuestionList.length <= 0 &&
                      props.scholasticQuestionList == "" ? null : (
                      <>
                        {showQuestion ? (
                          <div className="view_question_number_container">
                            <div className="left_arrow_container">
                              {props.questionNo === 0 ? (
                                <div className="icon_container">
                                  <div className="arrow_text text-muted">Pre</div>
                                  <div>
                                    <i className="bi bi-chevron-left text-warning text-muted"></i>
                                  </div>
                                </div>
                              ) : (
                                <Link to="#">
                                  <div
                                    className="icon_container"
                                    onClick={() =>
                                      prevousQuestion(props.questionNo)
                                    }
                                  >
                                    <div className="arrow_text">Pre</div>
                                    <div>
                                      <i className="bi bi-chevron-left text-warning"></i>
                                    </div>
                                  </div>
                                </Link>
                              )}
                            </div>
                            <div className="question_display">
                              {/* Displaying{" "} */}
                              <span className="text-warning count_number">
                                {props.questionNo + 1}
                              </span>{" "}
                              of{" "}
                              <span className="text-warning count_number">
                                {props.scholasticQuestionList.length}
                              </span>{" "}
                              Questions
                            </div>

                            <div className="right_arrow_container">
                              {props.questionNo ===
                                props.scholasticQuestionList.length - 1 ? (
                                <div className="icon_container">
                                  <div>
                                    <i className="bi bi-chevron-right text-warning text-muted"></i>
                                  </div>
                                  <div className="arrow_text text-muted">
                                    Next
                                  </div>
                                </div>
                              ) : (
                                <Link to="#">
                                  <div
                                    className="icon_container"
                                    onClick={() => nextQuestion(props.questionNo)}
                                  >
                                    <div>
                                      <i className="bi bi-chevron-right text-warning"></i>
                                    </div>
                                    <div className="arrow_text">Next</div>
                                  </div>
                                </Link>
                              )}
                            </div>
                          </div>
                        ) : null}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="rounded bg-white" style={{ flex: '0 0 23.5%', height: '80vh' }}>
                <div className="question_no_container">
                  <div className="select_question_number">
                    <div className="inside_select_question_number">
                      {showQuestion
                        ? props.scholasticQuestionList.map((item, index) => {
                          return (
                            <React.Fragment key={index}>
                              <Link to="#">
                                <div
                                  className={`question_number ${item.is_visited == 1
                                    ? `blue_background`
                                    : item.is_answered == 1
                                      ? `green_background_one `
                                      : `orange_background`
                                    } ${index == props.questionNo
                                      ? `selectQuestionBox`
                                      : ""
                                    }`}
                                  onClick={() => questNumber(index)}
                                >
                                  <div className="que_number">{index + 1}</div>
                                </div>
                              </Link>
                            </React.Fragment>
                          );
                        })
                        : null}
                    </div>
                  </div>
                  <div className="count_status_question">
                    <div className="count_container green_background_one">
                      <div className="count_number">
                        {showQuestion ? is_answered_count : 0}
                      </div>
                      <div className="count_status">Answered</div>
                    </div>
                    <div className="count_container blue_background">
                      <div className="count_number">
                        {showQuestion ? is_visited_count : 0}
                      </div>
                      <div className="count_status">Visited</div>
                    </div>
                    <div className="count_container orange_background">
                      <div className="count_number">
                        {showQuestion
                          ? props.scholasticQuestionList.length - is_visited_count
                          : 0}
                      </div>
                      <div className="count_status">Not Visited</div>
                    </div>
                  </div>
                  <div className="submit_container">
                    <Link to="#">
                      <div
                        className="btn btn-warning blue_background text-center"
                        onClick={submitFinalAnswerWithAlert}
                      >
                        Submit
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="exam_list_container">
            <div className="spinner-container">
              <div className="spinner-view">
                <Spinner
                  as="span"
                  animation="border"
                  //size="sm"
                  role="status"
                  aria-hidden="true"
                />
              </div>
            </div>
          </div>
        )}

        <Modal className="fade" show={instructionExamModal} scrollable={true}>
          <Modal.Header>
            <Modal.Title className="modal_title">
              Basic instructions for online examinations:
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ExamInstruction />
          </Modal.Body>
          <Modal.Footer>
            <div className="modal_footer_container">
              <div className="modal_footer_left_container">
                <p className="footer_text">Good Luck</p>
                <p className="footer_text">Team Crestest</p>
              </div>
              <div className="modal_footer_right_container">
                <Button
                  variant="danger text-center modal_footer_button"
                  onClick={() => history.goBack()}
                >
                  Quit exam
                </Button>
                <Button
                  variant="success text-center modal_footer_button"
                  onClick={startExam}
                >
                  Start exam
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal className="fade" show={informationModal} scrollable={true}>
          <Modal.Header>
            <Modal.Title className="modal_title">
              Basic instructions for online examinations:
            </Modal.Title>
            <Button
              variant=""
              className="btn-close"
              onClick={() => setInformationModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <ExamInstruction />
          </Modal.Body>
          <Modal.Footer>
            <div className="modal_footer_container_info">
              <div className="modal_footer_left_container">
                <p className="footer_text">Good Luck</p>
                <p className="footer_text">Team Crestest</p>
              </div>
              <div className="modal_footer_right_container">
                <Button
                  variant="danger text-center modal_footer_button"
                  onClick={() => setInformationModal(false)}
                >
                  Close
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal className="fade" show={isPlaying ? timeUpModal : false}>
          <Modal.Header>
            <Modal.Title className="modal_title">Timeup</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Click on submit button to view your assessment
          </Modal.Body>
          <Modal.Footer>
            <div className="modal_footer_container_info">
              <div className="modal_footer_left_container">
                <p className="footer_text">Good Luck</p>
                <p className="footer_text">Team Crestest</p>
              </div>
              <div className="modal_footer_right_container">
                <Button
                  variant="warning text-center modal_footer_button"
                  onClick={timeUpSubmit}
                >
                  Submit
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal className="fade" show={registrationModal}>
          <Modal.Header>
            <Modal.Title className="modal_title">
              Register yourself to view your assessment report
              <br />
              <span className="font-w500 register_text">
                (<span className="mandatory_color">*</span>) Marked fields are
                mandatory to fill
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col-lg-12">
              <div className="basic-form registration">
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="row">
                    <div className="col-sm-6 mb-2">
                      <label>
                        First name <span className="mandatory_color">*</span>
                      </label>
                      <input
                        ref={fnameRef}
                        type="text"
                        className="form-control input_value"
                        placeholder="Enter first name"
                        onChange={(e) => onFnameHandler(e.target.value)}
                        value={userDetails.fname}
                        autoComplete="off"
                        // onKeyPress={utility.inputAlphabetOnly}
                        onKeyPress={utility.inputAlphabetOnlyWithSpace}
                      />
                      {errors.fname && (
                        <div className="text-danger fs-12">{errors.fname}</div>
                      )}
                    </div>

                    <div className="col-sm-6 mb-2">
                      <label>
                        Last name <span className="mandatory_color">*</span>
                      </label>
                      <input
                        ref={lnameRef}
                        type="text"
                        className="form-control input_value"
                        placeholder="Enter last name"
                        onChange={(e) => onLnameHandler(e.target.value)}
                        value={userDetails.lname}
                        autoComplete="off"
                        // onKeyPress={utility.inputAlphabetOnly}
                        onKeyPress={utility.inputAlphabetOnlyWithSpace}
                      />
                      {errors.lname && (
                        <div className="text-danger fs-12">{errors.lname}</div>
                      )}
                    </div>

                    <div className="col-sm-6 mb-2">
                      <label>
                        Mobile <span className="mandatory_color">*</span>
                      </label>
                      <input
                        ref={mobileRef}
                        type="text"
                        className="form-control input_value"
                        placeholder="Enter mobile no"
                        onChange={(e) => onMobileHandler(e.target.value)}
                        value={userDetails.mobile}
                        autoComplete="off"
                        maxLength={10}
                        onKeyPress={utility.inputNumberOnly}
                      />
                      {errors.mobile && (
                        <div className="text-danger fs-12">{errors.mobile}</div>
                      )}
                    </div>

                    <div className="col-sm-6 mb-2">
                      <label>
                        Email <span className="mandatory_color">*</span>
                      </label>
                      <input
                        ref={emailRef}
                        type="text"
                        className="form-control input_value"
                        placeholder="Enter email ID"
                        onChange={(e) => onEmailHandler(e.target.value)}
                        value={userDetails.email}
                        autoComplete="off"
                      />
                      {errors.email && (
                        <div className="text-danger fs-12">{errors.email}</div>
                      )}
                    </div>

                    <div className="col-sm-6 mb-2">
                      <label>
                        Board <span className="mandatory_color">*</span>
                      </label>
                      <div className="form-control select_div_board">
                        <select
                          ref={boardRef}
                          defaultValue={"option"}
                          className="select_option_gender input_value"
                          value={userDetails.board}
                          onChange={(e) => onBoardHandler(e.target.value)}
                        >
                          <option value={defalutValueBlank}>
                            Select board
                          </option>
                          {props.boardList.map((item, index) => {
                            return (
                              <option
                                key={index}
                                value={[item.id, item.short_code, item.name]}
                              >
                                {item.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {errors.board && (
                        <div className="text-danger fs-12">{errors.board}</div>
                      )}
                    </div>

                    <div className="col-sm-6 mb-2">
                      <label>
                        Standard <span className="mandatory_color">*</span>
                      </label>
                      <div className="form-control select_div_standard">
                        <select
                          ref={stdRef}
                          defaultValue={"option"}
                          className="select_option_gender input_value"
                          value={userDetails.std}
                          onChange={(e) => onClassHandler(e.target.value)}
                        >
                          <option value="">Select standard</option>
                          {props.classStandardList.map((item, index) => {
                            return (
                              <option key={index} value={item.class_no}>
                                {item.short_code}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {errors.std && (
                        <div className="text-danger fs-12">{errors.std}</div>
                      )}
                    </div>

                    <div className="col-sm-12 mb-2">
                      <label>
                        Academic year <span className="mandatory_color">*</span>
                      </label>
                      <div className="form-control select_div_standard">
                        <select
                          ref={academicRef}
                          className="select_option_gender input_value"
                          value={userDetails.academic}
                          onChange={(e) => onAcademicHandler(e.target.value)}
                        >
                          <option value={defalutValueBlank}>
                            Select academic year
                          </option>
                          {props.academicList.map((item, index) => {
                            return (
                              <option key={index} value={item.id}>
                                {item.academicyear}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {errors.academic && (
                        <div className="text-danger fs-12">
                          {errors.academic}
                        </div>
                      )}
                    </div>



                  </div>
                </form>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="modal_footer_container_info">
              <div className="modal_footer_left_container">
                <p className="footer_text">Good Luck</p>
                <p className="footer_text">Team Crestest</p>
              </div>
              <div className="modal_footer_right_container">
                {/* <Link to="/dashboard"> */}
                <Button
                  variant="danger text-center modal_footer_button"
                  // onClick={() => setRegistrationModal(false)}
                  onClick={() => backToDashboard()}
                >
                  Close
                </Button>
                {/* </Link> */}
                <Button
                  variant="warning text-center modal_footer_button"
                  onClick={demouserRegister}
                  autoFocus={true}
                >
                  Submit
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal className="fade" show={otpVerificationModal}>
          <Modal.Header>
            <Modal.Title className="modal_title">
              Verify Your Contact Information
            </Modal.Title>{" "}
            {/* (M:{utility.decryptAES(props.mOtp)}, E:{" "}
            {utility.decryptAES(props.eOtp)}) */}
            <div className="optLoader">
              {/* {console.log("=======@@111=====", `M: ${utility.decryptAES(props.mOtp)}, E: ${utility.decryptAES(props.eOtp)}`)} */}
              {props.mOtp != "" && props.eOtp != "" ? (
                <>
                  <div className="timer-wrapper">
                    <CountdownCircleTimer
                      isPlaying
                      duration={props.otpValidTime * 60}
                      colors={["#004777", "#F7B801", "#ff0000", "#ff0000"]}
                      // colorsTime={[10, 6, 3, 0]}
                      colorsTime={[50, 50, 50, 0]}
                      onComplete={() => ({ shouldRepeat: false, delay: 1 })}
                      size={30}
                      strokeWidth={3}
                    >
                      {renderTime}
                    </CountdownCircleTimer>
                  </div>
                  <div className="small_text">Seconds Remaining </div>
                </>
              ) : null}
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="col-lg-12">
              <div className="basic-form">
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="row">
                    <div className="col-sm-6 mb-2">
                      <label className="col-sm-6 col-form-label col-form-label-md">
                        Mobile OTP
                      </label>
                      <input
                        ref={mobileOtpRef}
                        type="text"
                        className="form-control input_value"
                        placeholder="Mobile OTP"
                        onChange={(e) => onMotpHandler(e.target.value)}
                        value={userDetails.motp}
                        autocomplete="off"
                        maxLength={6}
                      />
                      {errors.motp && (
                        <div className="text-danger fs-12">{errors.motp}</div>
                      )}
                    </div>
                    <div className="col-sm-6 mb-2">
                      <label className="col-sm-6 col-form-label col-form-label-md">
                        Email OTP
                      </label>
                      <input
                        ref={emailOtpRef}
                        type="text"
                        className="form-control input_value"
                        placeholder="Email OTP"
                        onChange={(e) => onEotpHandler(e.target.value)}
                        value={userDetails.eotp}
                        autocomplete="off"
                        maxLength={6}
                      />
                      {errors.eotp && (
                        <div className="text-danger fs-12">{errors.eotp}</div>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="modal_footer_container_info">
              <div className="modal_footer_left_container">
                <p className="footer_text">Good Luck</p>
                <p className="footer_text">Team Crestest</p>
              </div>
              <div className="modal_footer_right_container">
                <Button
                  variant="danger text-center modal_footer_button"
                  onClick={() => closeOtpVerificationModal()}
                >
                  Close
                </Button>
                {verifyButtonShow ? (
                  <Button
                    variant="warning text-center modal_footer_button"
                    onClick={verifyOtp}
                  >
                    Verify
                  </Button>
                ) : null}
                {showResendOtp ? (
                  <Button
                    variant="warning text-center modal_footer_button"
                    onClick={resendOtp}
                  >
                    Resend OTP
                  </Button>
                ) : null}
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </div>

      <div>
        <TermsCondition
          termsAndConditionModal={termsAndConditionModal}
          termsConditionSubmit={() => checkUserRecord()}
          closeTermsConsition={() => SetTermsAndConditionModal(false)}
        />
      </div>

      <div>{props.studentLoader ? <Loader /> : null}</div>
      <div>
        {/* {alertSound == 1 ? */}
        {warningSound == 1 ? (
          <>
            {/* <CounterClockSoundComponent isPlaying={alertSound == 1 ? true : false} /> */}
            <CounterClockSoundComponent
              isPlaying={warningSound == 1 ? true : false}
            />
          </>
        ) : null}
      </div>
      <div>
        <ToastContainer />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    newuserId: state.student.newStudentid,
    eOtp: state.student.email_otp,
    mOtp: state.student.mobile_otp,
    otpValidTime: state.student.otpValidTime,
    user_id: state.auth.user_id,
    user_name: state.auth.fname,
    questionNo: state.questionNo.currentQestionNo,
    scholasticQuestionList: state.branch.scholasticQuestionList,
    showLoadingBranchScholastic: state.branch.showLoadingBranchScholastic,
    classStandardList: state.standard.classStandardList,
    showLoading: state.board.showLoading,
    boardList: state.board.boardList,
    studentLoader: state.student.showLoading,
    schoolList: state.board.schoolList,
    schoolNameShowingLoader: state.board.schoolNameShowingLoader,
    academicList: state.academic.academicMasterList,
  };
};
export default connect(mapStateToProps)(DemoScholasticExamStart);
